// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadTranslations as loadTranslationsAnnotationTriage } from '@admin-panel/annotation-triage/locales'
import { loadTranslations as loadTranslationsApPricing } from '@admin-panel/ap-pricing/locales'
import { loadTranslations as loadTranslationsApServiceSettings } from '@admin-panel/ap-service-settings/locales'
import { loadTranslations as loadTranslationsEvaluationAi } from '@admin-panel/evaluation-ai/locales'
import { loadTranslations as loadTranslationsFleetPlanner } from '@admin-panel/fleet-planner/locales'
import { loadTranslations as loadTranslationsGlobalVehicleManagement } from '@admin-panel/global-vehicle-management/locales'
import { loadTranslations as loadTranslationsHulkTrips } from '@admin-panel/hulk-trips/locales'
import { loadTranslations as loadTranslationsIncidentAnalysis } from '@admin-panel/incident-analysis/locales'
import { loadTranslations as loadTranslationsRouteBuilder } from '@admin-panel/route-builder/locales'
import { loadTranslations as loadTranslationsSafetyDriverAnnotations } from '@admin-panel/safety-driver-annotations/locales'
import { loadTranslations as loadTranslationsTemporaryBackofficeSessions } from '@admin-panel/temporary-backoffice-sessions/locales'
import { loadTranslations as loadTranslationsTripHistory } from '@admin-panel/trip-history/locales'
import { loadTranslations as loadTranslationsUserManagement } from '@admin-panel/user-management/locales'
import { loadTranslations as loadTranslationsVehicleDataOverride } from '@admin-panel/vehicle-data-override/locales'
import { loadTranslations as loadTranslationsVehicleMonitoring } from '@admin-panel/vehicle-monitoring/locales'
import { loadTranslations as loadTranslationsVirtualTesting } from '@admin-panel/virtual-testing/locales'
import { loadTranslations as loadTranslationsFleetDashboard } from '@backoffice/fleet-dashboard/locales'
import { loadTranslations as loadTranslationsFleetTracing } from '@backoffice/fleet-tracing/locales'
import { loadTranslations as loadTranslationsInAppMessages } from '@backoffice/in-app-messages/locales'
import { loadTranslations as loadTranslationsRemoteAssistanceOperator } from '@backoffice/remote-assistance-operator/locales'
import { loadTranslations as loadTranslationsRiderFeedback } from '@backoffice/rider-feedback/locales'
import { loadTranslations as loadTranslationsRiderSupport } from '@backoffice/rider-support/locales'
import { loadTranslations as loadTranslationsRoadNetwork } from '@backoffice/road-network/locales'
import { loadTranslations as loadTranslationsTracing } from '@backoffice/tracing/locales'
import { loadTranslations as loadTranslationsTripApiConfiguration } from '@backoffice/trip-api-configuration/locales'
import { loadTranslations as loadTranslationsUserManagementOrganization } from '@backoffice/user-management-organization/locales'
import { loadTranslations as loadTranslationsVehicleCapacityConfig } from '@backoffice/vehicle-capacity-config/locales'
import { loadTranslations as loadTranslationsVehiclePlans } from '@backoffice/vehicle-plans/locales'
import { loadTranslations as loadTranslationsAccidentsReports } from '@backoffice-frontend/accidents-reports/locales'
import { loadTranslations as loadTranslationsAccounting } from '@backoffice-frontend/accounting/locales'
import { loadTranslations as loadTranslationsAdConfiguration } from '@backoffice-frontend/ad-configuration/locales'
import { loadTranslations as loadTranslationsAdFleetMap } from '@backoffice-frontend/ad-fleet-map/locales'
import { loadTranslations as loadTranslationsAlerts } from '@backoffice-frontend/alerts/locales'
import { loadTranslations as loadTranslationsAppAccessControl } from '@backoffice-frontend/app-access-control/locales'
import { loadTranslations as loadTranslationsCapacityPlanning } from '@backoffice-frontend/capacity-planning/locales'
import { loadTranslations as loadTranslationsCoupon } from '@backoffice-frontend/coupon/locales'
import { loadTranslations as loadTranslationsCustomer } from '@backoffice-frontend/customer/locales'
import { loadTranslations as loadTranslationsCustomerFeatureAllowlisting } from '@backoffice-frontend/customer-feature-allowlisting/locales'
import { loadTranslations as loadTranslationsDemoRoutes } from '@backoffice-frontend/demo-routes/locales'
import { loadTranslations as loadTranslationsDisruptions } from '@backoffice-frontend/disruptions/locales'
import { loadTranslations as loadTranslationsDriverTipping } from '@backoffice-frontend/driver-tipping/locales'
import { loadTranslations as loadTranslationsDsBoss } from '@backoffice-frontend/ds-boss/locales'
import { loadTranslations as loadTranslationsEmployee } from '@backoffice-frontend/employee/locales'
import { loadTranslations as loadTranslationsEmployeeTimeManagement } from '@backoffice-frontend/employee-time-management/locales'
import { loadTranslations as loadTranslationsFleetMaintenance } from '@backoffice-frontend/fleet-maintenance/locales'
import { loadTranslations as loadTranslationsFleetMap } from '@backoffice-frontend/fleet-map/locales'
import { loadTranslations as loadTranslationsFleetPerformanceOverview } from '@backoffice-frontend/fleet-performance-overview/locales'
import { loadTranslations as loadTranslationsFleets } from '@backoffice-frontend/fleets/locales'
import { loadTranslations as loadTranslationsKpiDashboard } from '@backoffice-frontend/kpi-dashboard/locales'
import { loadTranslations as loadTranslationsLegalDocumentManagement } from '@backoffice-frontend/legal-document-management/locales'
import { loadTranslations as loadTranslationsMobileAppFlavorConfig } from '@backoffice-frontend/mobile-app-flavor-config/locales'
import { loadTranslations as loadTranslationsMobileAppstoreAssets } from '@backoffice-frontend/mobile-appstore-assets/locales'
import { loadTranslations as loadTranslationsOfferAndPooling } from '@backoffice-frontend/offer-and-pooling/locales'
import { loadTranslations as loadTranslationsPassengerApp } from '@backoffice-frontend/passenger-app/locales'
import { loadTranslations as loadTranslationsPricing } from '@backoffice-frontend/pricing/locales'
import { loadTranslations as loadTranslationsReportIo } from '@backoffice-frontend/report-io/locales'
import { loadTranslations as loadTranslationsSafetyDriverGuidance } from '@backoffice-frontend/safety-driver-guidance/locales'
import { loadTranslations as loadTranslationsServiceBreakLocations } from '@backoffice-frontend/service-break-locations/locales'
import { loadTranslations as loadTranslationsServiceSettings } from '@backoffice-frontend/service-settings/locales'
import { loadTranslations as loadTranslationsShifts } from '@backoffice-frontend/shifts/locales'
import { loadTranslations as loadTranslationsShiftsCreation } from '@backoffice-frontend/shifts-creation/locales'
import { loadTranslations as loadTranslationsStatus } from '@backoffice-frontend/status/locales'
import { loadTranslations as loadTranslationsStopNetwork } from '@backoffice-frontend/stop-network/locales'
import { loadTranslations as loadTranslationsTrip } from '@backoffice-frontend/trip/locales'
import { loadTranslations as loadTranslationsVehicle } from '@backoffice-frontend/vehicle/locales'
import { loadTranslations as loadTranslationsVehicleAlerts } from '@backoffice-frontend/vehicle-alerts/locales'
import { loadTranslations as loadTranslationsWelcome } from '@backoffice-frontend/welcome/locales'
import { loadTranslations as loadTranslationsWelcomeAdminPanel } from '@backoffice-frontend/welcome-admin-panel/locales'
import { loadTranslations as loadTranslationsUpdates } from '@shared/updates/locales'

export const loadSharedAreaTranslations = () => {
  loadTranslationsUpdates()
  loadTranslationsStatus()
  loadTranslationsPassengerApp()
  loadTranslationsWelcome()
  loadTranslationsWelcomeAdminPanel()
  loadTranslationsTemporaryBackofficeSessions()
  loadTranslationsUserManagement()
  loadTranslationsIncidentAnalysis()
  loadTranslationsVirtualTesting()
  loadTranslationsApServiceSettings()
  loadTranslationsApPricing()
  loadTranslationsFleetPlanner()
  loadTranslationsGlobalVehicleManagement()
  loadTranslationsUserManagementOrganization()
  loadTranslationsRouteBuilder()
  loadTranslationsAnnotationTriage()
  loadTranslationsFleetMap()
  loadTranslationsAccounting()
  loadTranslationsAdConfiguration()
  loadTranslationsAdFleetMap()
  loadTranslationsRemoteAssistanceOperator()
  loadTranslationsSafetyDriverGuidance()
  loadTranslationsAlerts()
  loadTranslationsCoupon()
  loadTranslationsCustomer()
  loadTranslationsKpiDashboard()
  loadTranslationsDriverTipping()
  loadTranslationsEmployee()
  loadTranslationsEmployeeTimeManagement()
  loadTranslationsFleetMaintenance()
  loadTranslationsPricing()
  loadTranslationsShifts()
  loadTranslationsCapacityPlanning()
  loadTranslationsShiftsCreation()
  loadTranslationsStopNetwork()
  loadTranslationsRoadNetwork()
  loadTranslationsServiceBreakLocations()
  loadTranslationsTrip()
  loadTranslationsEvaluationAi()
  loadTranslationsTripHistory()
  loadTranslationsHulkTrips()
  loadTranslationsVehicle()
  loadTranslationsVehicleAlerts()
  loadTranslationsDemoRoutes()
  loadTranslationsDsBoss()
  loadTranslationsOfferAndPooling()
  loadTranslationsServiceSettings()
  loadTranslationsCustomerFeatureAllowlisting()
  loadTranslationsAccidentsReports()
  loadTranslationsReportIo()
  loadTranslationsDisruptions()
  loadTranslationsFleets()
  loadTranslationsLegalDocumentManagement()
  loadTranslationsFleetDashboard()
  loadTranslationsRiderSupport()
  loadTranslationsFleetTracing()
  loadTranslationsTracing()
  loadTranslationsVehiclePlans()
  loadTranslationsMobileAppstoreAssets()
  loadTranslationsAppAccessControl()
  loadTranslationsRiderFeedback()
  loadTranslationsFleetPerformanceOverview()
  loadTranslationsMobileAppFlavorConfig()
  loadTranslationsInAppMessages()
  loadTranslationsVehicleCapacityConfig()
  loadTranslationsTripApiConfiguration()
  loadTranslationsSafetyDriverAnnotations()
  loadTranslationsVehicleDataOverride()
  loadTranslationsVehicleMonitoring()
}
